<template>
  <div class="search-form">
    <transition name="fly">
      <div @click="toggleSearch()" v-show="searchHidden">
        <p class="form-control text-muted fake-input">
          Filter...
          <span class="pt-1 fa fa-search float-right"></span>
        </p>
      </div>
    </transition>
    <transition name="fly">
      <div class="clearfix" v-show="!searchHidden">
        <p class="text-right">
          <button class="btn btn-danger btn-sm" type="button" @click="toggleSearch()">
            <span class="fa fa-times"></span>
            <strong>Hide Search</strong>
          </button>
        </p>
        <vue-form
          :options="formOptions"
          @load="search()"
          :is-modal="true"
          ref="searchForm"
          v-if="formOptions">
        </vue-form>
      </div>
    </transition>
    <div class="text-right my-2">
      <button class="btn btn-primary" v-if="allowToggle" @click="$emit('toggleDisplay')">
        <span class="fa fa-fw" :class="!tableDisplay ? 'fa-bars' : 'fa-table'"></span>
        Toggle Display
      </button>
      <button class="btn btn-primary" type="button" @click="search()">
        <span class="fa fa-sync"></span> Refresh
      </button>
    </div>
    <div class="alert alert-danger" v-if="!results.length">No results.</div>
    <template v-else>
      <paging-input @change="updatePage($event)" :options="{
        totalResults,
        centered: true,
        current,
        limit: limit
      }">
      </paging-input>
      <responsive-table :hide-title="true" :table="{ columns }" v-if="tableDisplay">
        <template slot="rows">
          <template v-for="(row, i) in results">
            <component :is="parseType(formOptions.permalink) + '-row'" :object="row" :index="i" :key="i"></component>
          </template>
        </template>
      </responsive-table>
      <template v-else>
        <template v-for="(object, i) in results">
          <div class="list-group-item" :class="{ 'bg-light': i % 2 == 0 }" :key="i">
            <component :is="parseType(formOptions.permalink) + '-display'" :data="object"></component>
          </div>
        </template>
      </template>
      <paging-input class="mt-3" @change="updatePage($event)" :options="{
        totalResults,
        centered: true,
        current,
        limit: limit}">
      </paging-input>
    </template>
  </div>
</template>

<script>
import AccountFileRow from '@/components/rows/AccountFile'
import AccountNoteDisplay from '@/components/displays/AccountNoteDisplay'
import CarDamageDisplay from '@/components/displays/CarDamageDisplay'
import CarMessageDisplay from '@/components/displays/CarMessageDisplay'
import TekboxMessageDisplay from '@/components/displays/TekboxMessageDisplay'
import DriverRow from '@/components/rows/Driver'
import LedgerRow from '@/components/rows/Ledger'
import PagingInput from '@/components/inputs/PagingInput'
import ReservationDisplay from '@/components/displays/ReservationDisplay'
import ReservationRow from '@/components/rows/UserReservation'
import ResponsiveTable from '@/components/ResponsiveTable'
import VueForm from '@/components/Form'
import { MODIFY_FORM_VALUE } from '@/vuex/types'

export default {
  name: 'SearchForm',
  components: {
    AccountFileRow,
    AccountNoteDisplay,
    CarDamageDisplay,
    CarMessageDisplay,
    DriverRow,
    LedgerRow,
    PagingInput,
    ReservationDisplay,
    ReservationRow,
    ResponsiveTable,
    TekboxMessageDisplay,
    VueForm
  },
  props: {
    options: {
      type: Object,
      default () {
        return {
          permalink: false,
          title: 'Loading Form...',
          submit: 'Loading...',
          submitting: 'Processing...',
          confirmation: false,
          redirect: '/',
          params: false
        }
      }
    },
    results: {
      type: Array,
      default () {
        return []
      }
    },
    type: {
      type: String,
      default () {
        return ''
      }
    },
    columns: {
      type: Array,
      default () {
        return [
          { title: 'ID', span: 4 },
          { title: 'Data', span: 4 },
          { title: 'Status', span: 4 }
        ]
      }
    },
    totalResults: {
      type: Number,
      default () {
        return 0
      }
    },
    tableDisplay: {
      type: Boolean,
      default () {
        return false
      }
    },
    allowToggle: {
      type: Boolean,
      default () {
        return false
      }
    }
  },
  computed: {
    formOptions () {
      return {
        ...this.options
      }
    },
    current () {
      return this.currentPage || 1
    }
  },
  data () {
    return {
      searchHidden: true,
      currentPage: false,
      limit: 10
    }
  },
  methods: {
    toggleSearch () {
      this.searchHidden = !this.searchHidden
    },
    async search () {
      this.currentPage = 1
      this.$store.commit(MODIFY_FORM_VALUE, {
        permalink: this.options.permalink,
        name: 'offset',
        value: 0
      })
      this.refresh()
    },
    async refresh () {
      await this.$nextTick()
      this.$refs.searchForm.submitForm()
      for (let section of this.$refs.searchForm.form.sections) {
        if (section.name === 'limit') this.limit = section.value
      }
    },
    async updatePage (page) {
      this.currentPage = page
      this.$store.commit(MODIFY_FORM_VALUE, {
        permalink: this.options.permalink,
        name: 'offset',
        value: (page - 1) * this.limit
      })
      this.refresh()
    },
    parseType (permalink) {
      switch (permalink) {
        case 'getCarMessages':
          if (this.type === 'tekbox') {
            return 'tekbox-message'
          }
          return 'car-message'
        case 'getCarReservations':
        case 'getUserReservations':
          return 'reservation'
        case 'getUserNotes':
        case 'getCarNotes':
        case 'getReservationNotes':
          return 'account-note'
        case 'getCarDamages':
          return 'car-damage'
        case 'getUserFiles':
          return 'account-file'
        case 'getUserDrivers':
          return 'driver'
        case 'getLedger':
          return 'ledger'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SearchForm.vue